// extracted by mini-css-extract-plugin
var _1 = "ButtonIcon_icon__4b008";
export { _1 as "icon" }
